<div style="padding: 20px;">

    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list" class="nav-item" (click)="choosetag(item.id)">
            <span style="cursor:pointer" [ngClass]="now==item.id?'active':''" class="nav-link">{{item.name}}</span>
        </li>
    </ul>

    <!-- ===================== 用戶整體行為 ===================== -->
    <div *ngIf="now=='0'">

        <!-- 篩選條件集中在圖表上方一列 -->
        <div class="ub-filters">
            <input type="text" *ngIf="time" class="form-control ub-date"
                ngxDaterangepickerMd
                [(ngModel)]="time"
                [autoApply]="true"
                [ranges]="ranges"
                [alwaysShowCalendars]="true"
                [locale]="{applyLabel: 'ok', format: 'YYYY-MM-DD'}"
                [opens]="'right'"
                [minDate]="time.minDate"
                [maxDate]="time.maxDate"
                (change)="onRangeSelected($event)">

            <select class="form-control ub-select" [(ngModel)]="page_filter" (change)="changePageFilter()">
                <option *ngFor="let item of page_options" [ngValue]="item.id">{{item.name}}</option>
            </select>

            <span class="ub-range-note" *ngIf="summary?.batch_count >= 0">
                {{time.start}} ~ {{time.end}}
            </span>

            <button class="btn btn-outline-secondary ub-help-btn" (click)="show_help = !show_help">
                {{show_help ? '收起說明 ▲' : '這頁在看什麼？▼'}}
            </button>
        </div>

        <!-- 給非工程背景的人看的說明,預設收合 -->
        <div class="ub-help" *ngIf="show_help">
            <p><strong>這頁在統計什麼：</strong>App 裡埋了行為記錄點 —— 用戶每次「進入某個頁面」或「點擊某個按鈕」，
                App 就記下一筆<strong>事件</strong>，等下次打開 App 時整批上傳（一次上傳＝一個<strong>批次</strong>）。
                這頁就是把這些事件加總起來，看用戶都在 App 裡做什麼、哪些功能有人用。</p>
            <ul>
                <li><strong>事件總數</strong>：期間內記錄到的動作總次數。</li>
                <li><strong>活躍用戶</strong>：期間內有上傳過行為紀錄的「不重複」用戶數 —— 同一個人用了 5 天也只算 1 人。</li>
                <li><strong>上傳批次</strong>：App 每次開啟時上傳一次＝1 批，可以粗略當成「App 被打開的次數」。</li>
                <li><strong>平均每人事件</strong>：事件總數 ÷ 活躍用戶，代表平均每個人做了幾個動作。</li>
                <li><strong>事件種類／涵蓋頁面</strong>：期間內出現過幾種不同的動作／幾個不同的 App 頁面。</li>
                <li><strong>日期以「上傳日」計</strong>：行為發生後要等下次開 App 才會上傳，所以少數行為會落到隔天的數字裡。</li>
                <li>「事件排行」表的灰色小字（如 <span class="ub-code">explore_enter</span>）是工程端的事件代碼，對照除錯用，看中文名稱即可。</li>
            </ul>
        </div>

        <!-- 掃描上限:明說被截斷,不做無聲截斷 -->
        <div class="ub-warn" *ngIf="truncated">
            ⚠ 這個區間的資料量已達單次掃描上限，以下數字只涵蓋區間內較早的部分。請縮小日期範圍再看。
        </div>
        <div class="ub-warn" *ngIf="load_error">⚠ {{load_error}}</div>
        <div class="ub-note" *ngIf="summary?.filtered">
            已套用頁面篩選，下方所有數字（含事件總數、活躍用戶、批次數）都只計算該頁面的事件；儲值路徑不受篩選影響。
        </div>

        <div *ngIf="summary?.total_events > 0">
            <!-- 每張卡都有 title,滑鼠停上去可看定義;完整說明在上方「這頁在看什麼?」 -->
            <div class="ub-tiles">
                <div class="ub-tile" title="期間內記錄到的動作總次數（進入頁面、點擊按鈕都算一次）">
                    <div class="ub-tile-label">事件總數</div>
                    <div class="ub-tile-value">{{summary.total_events | number}}</div>
                </div>
                <div class="ub-tile" title="期間內有上傳過行為紀錄的不重複用戶數：同一個人用了 5 天也只算 1 人（以上傳日計）">
                    <div class="ub-tile-label">活躍用戶<span class="ub-i">ⓘ</span></div>
                    <div class="ub-tile-value">{{summary.user_count | number}}</div>
                    <div class="ub-tile-hint">有上傳行為紀錄的不重複用戶</div>
                </div>
                <div class="ub-tile" title="App 每次開啟時整批上傳一次＝1 批，可粗略當成 App 被打開的次數">
                    <div class="ub-tile-label">上傳批次</div>
                    <div class="ub-tile-value">{{summary.batch_count | number}}</div>
                </div>
                <div class="ub-tile" title="事件總數 ÷ 活躍用戶＝平均每個人做了幾個動作">
                    <div class="ub-tile-label">平均每人事件</div>
                    <div class="ub-tile-value">{{summary.avg_per_user | number}}</div>
                </div>
                <div class="ub-tile" title="期間內出現過幾種不同的動作">
                    <div class="ub-tile-label">事件種類</div>
                    <div class="ub-tile-value">{{summary.event_kinds | number}}</div>
                </div>
                <div class="ub-tile" title="期間內出現過幾個不同的 App 頁面">
                    <div class="ub-tile-label">涵蓋頁面</div>
                    <div class="ub-tile-value">{{summary.page_kinds | number}}</div>
                </div>
            </div>

            <!-- 事件次數與活躍用戶量級不同,分成兩張各自單一序列的圖,不共用 y 軸 -->
            <div class="ub-charts">
                <div class="ub-chart">
                    <highcharts-chart [Highcharts]="Highcharts" [(update)]="eventUpdate"
                        [options]="eventChart" style="display:block; width:100%;"></highcharts-chart>
                </div>
                <div class="ub-chart">
                    <highcharts-chart [Highcharts]="Highcharts" [(update)]="userUpdate"
                        [options]="userChart" style="display:block; width:100%;"></highcharts-chart>
                </div>
            </div>

            <!-- 儲值轉化漏斗:規格指明這是最重要的分析鏈。人數為去重後的用戶數 -->
            <div class="ub-block" *ngIf="funnel?.length > 0">
                <div class="ub-block-title">儲值路徑<span class="ub-block-note">（各步為去重人數，不受上方頁面篩選影響。三步之間不是包含關係——「進入儲值頁」埋在儲值頁本身，鑽石不足彈窗等入口不會產生第一步的事件，所以第二步可能大於第一步；百分比以三步的最大值為基準。）</span></div>
                <div class="ub-funnel-row" *ngFor="let f of funnel">
                    <div class="ub-funnel-label">{{f.label}}</div>
                    <div class="ub-funnel-track">
                        <div class="ub-funnel-bar" [style.width.%]="f.pct"></div>
                    </div>
                    <div class="ub-funnel-value">{{f.uv | number}} 人<span class="ub-funnel-pct">{{f.pct}}%</span></div>
                </div>
            </div>

            <!-- 頁面熱度:分組展開視圖。每一頁都做成跟「儲值路徑」同一種讀法 ——
                 進入這頁有幾人當基準,往下列出頁內每個動作各有幾人、佔幾 % -->
            <div class="ub-block" *ngIf="page_groups?.length > 0">
                <div class="ub-block-title">頁面熱度與頁內行為
                    <span class="ub-block-note">（點任一頁面展開，看「進來的人都做了什麼」——與儲值路徑同一種讀法。長條以該頁人數最高的行為為
                        100%，通常是「進入」；但 App 從背景切回前景不會重記「進入」，所以個別動作的人數可能高於進入人數，與儲值路徑第二步可能大於第一步是同一種現象。）</span>
                </div>

                <div class="ub-pg-head">
                    <span class="ub-pg-toggle"></span>
                    <span class="ub-pg-name">頁面</span>
                    <span class="ub-pg-col">進入人數</span>
                    <span class="ub-pg-col ub-sortable" (click)="sortPageBy('cnt')">
                        事件次數 <span class="ub-sort-arrow">{{page_sort.col == 'cnt' ? (page_sort.desc ? '▼' : '▲') : ''}}</span>
                    </span>
                    <span class="ub-pg-col ub-sortable" (click)="sortPageBy('uv')">
                        人數 <span class="ub-sort-arrow">{{page_sort.col == 'uv' ? (page_sort.desc ? '▼' : '▲') : ''}}</span>
                    </span>
                </div>

                <div class="ub-batch" *ngFor="let g of page_groups">
                    <div class="ub-batch-head" (click)="toggle_group(g.page)">
                        <span class="ub-batch-toggle ub-pg-toggle">{{open_group[g.page] ? '▾' : '▸'}}</span>
                        <span class="ub-pg-name" [title]="g.page">{{pageLabel(g.page)}}</span>
                        <span class="ub-pg-col">{{g.enter_uv | number}} 人</span>
                        <span class="ub-pg-col">{{g.cnt | number}}</span>
                        <span class="ub-pg-col">{{g.uv | number}}</span>
                    </div>
                    <div class="ub-pg-body" *ngIf="open_group[g.page]">
                        <div class="ub-funnel-row" *ngFor="let it of g.items">
                            <div class="ub-funnel-label ub-pg-label" [title]="it.event">{{eventLabel(it.event) || it.event}}</div>
                            <div class="ub-funnel-track">
                                <div class="ub-funnel-bar" [style.width.%]="barWidth(it.pct)"></div>
                            </div>
                            <div class="ub-funnel-value ub-pg-value">
                                {{it.uv | number}} 人<span class="ub-funnel-pct">{{it.pct}}%</span>
                                <span class="ub-pg-cnt">{{it.cnt | number}} 次</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="ub-block">
            <div class="ub-block-title">事件排行</div>
            <app-table-v2 *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent" [data]="data"
                (sortdata)="handlesortdata($event)">
                <ng-template let-post #operation_dk>
                    <div *ngIf="post.key == 'event'">
                        <div class="ub-ev-name">{{eventLabel(post.val.event) || post.val.event}}</div>
                        <div class="ub-code">{{post.val.event}}</div>
                    </div>
                    <div *ngIf="post.key == 'page'">{{pageLabel(post.val.page)}}</div>
                    <div *ngIf="post.key == 'kind'">
                        <span class="ub-kind">{{kindLabel(post.val.event)}}</span>
                    </div>
                    <div *ngIf="post.key == 'pct'">{{post.val.pct}}%</div>
                </ng-template>
            </app-table-v2>
            <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
            <div *ngIf="data.length == 0" class="ub-empty">
                這個區間沒有任何行為埋點資料。若確定 App 已上線埋點，請確認 device_local_data 是否有 action = 5 的紀錄。
            </div>
        </div>
    </div>

    <!-- ===================== 個別用戶行為 ===================== -->
    <div *ngIf="now=='1'">

        <!-- 查詢面板:兩種找人方式做成切換,一次只顯示一種,結果固定出現在面板下方。
             用 [hidden] 而不是 *ngIf:切換時 Tag 的選取狀態與名單才不會被銷毀重建
             (app-tagselect 的選取存在它自己裡面,重建就跟父層手上的 groupTagArr 對不上)。 -->
        <div class="ub-panel" id="ub-search-panel">
            <div class="ub-panel-head">
                <div class="ub-seg">
                    <button type="button" class="ub-seg-btn" [ngClass]="{'active': find_mode === 'direct'}"
                        (click)="find_mode = 'direct'">直接查一個人</button>
                    <button type="button" class="ub-seg-btn" [ngClass]="{'active': find_mode === 'tag'}"
                        (click)="find_mode = 'tag'">用 Tag 找人</button>
                </div>
                <span class="ub-panel-hint" *ngIf="find_mode === 'direct'">輸入 uid / 暱稱 / 手機 / 數字ID，Enter 或按「查詢」</span>
                <span class="ub-panel-hint" *ngIf="find_mode === 'tag'">與「用戶列表」頁的 Tag 相同：先圈出一群人，再點「查看行為」</span>
            </div>

            <!-- 直接查一個人 -->
            <div class="ub-panel-body" [hidden]="find_mode !== 'direct'">
                <div class="ub-filters ub-filters-flat">
                    <input type="text" class="form-control ub-search" [(ngModel)]="search_model"
                        (keyup.enter)="search_user()" placeholder="輸入 uid / 暱稱 / 手機 / 數字ID">
                    <button class="btn btn-primary" (click)="search_user()">查詢</button>
                </div>
            </div>

            <!-- 用 Tag 找人(app-tagselect 自己撈 tag 清單,與用戶列表頁同一套資料) -->
            <div class="ub-panel-body" [hidden]="find_mode !== 'tag'">
                <app-tagselect (item)="calltagList($event)"></app-tagselect>

                <div class="ub-filters" style="margin-top: 10px;">
                    <span class="ub-inline-label">Tag 統計時間</span>
                    <select class="form-control ub-select" [(ngModel)]="tag_time">
                        <option *ngFor="let item of tag_time_list" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <button class="btn btn-primary" (click)="search_by_tag(true)">搜尋用戶</button>
                    <span class="ub-range-note" *ngIf="tag_update_dt">Tag 資料更新於 {{tag_update_dt}}</span>
                </div>

                <div class="ub-warn" *ngIf="tag_msg">{{tag_msg}}</div>

                <!-- 正在看的那個人整列上色,捲回名單時知道剛才點的是誰 -->
                <table class="ub-table" *ngIf="tag_users.length > 0">
                    <thead>
                        <tr><th style="width:48px;"></th><th>用戶</th><th>性別</th><th class="ub-num">鑽石</th><th style="width:110px;"></th></tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let u of tag_users" class="ub-click-row"
                            [ngClass]="{'ub-row-active': user && u.uid === user.uid}" (click)="pick_tag_user(u)">
                            <td><img *ngIf="u.profile_pic" [src]="u.profile_pic" class="ub-avatar-s"></td>
                            <td>
                                <div class="ub-ev-name">{{u.name}}</div>
                                <div class="ub-code">{{u.uid}}</div>
                            </td>
                            <td>{{u.gender == 1 ? '男' : (u.gender == 2 ? '女' : '-')}}</td>
                            <td class="ub-num">{{u.diamond | number}}</td>
                            <td><button class="btn btn-primary btn-sm" (click)="pick_tag_user(u); $event.stopPropagation()">查看行為</button></td>
                        </tr>
                    </tbody>
                </table>
                <app-pagnation *ngIf="tag_users.length > 0" (callback)="tag_callback($event)" [data]="tag_pageobjstr"></app-pagnation>
            </div>
        </div>

        <div class="ub-warn" *ngIf="user_msg">{{user_msg}}</div>

        <!-- 查詢結果。id 是錨點:從 Tag 名單點「查看行為」後自動捲到這裡,名單很長時才不會找不到結果 -->
        <div *ngIf="user" id="ub-user-result" class="ub-result">
            <div class="ub-result-bar">
                <span class="ub-result-title">查詢結果</span>
                <button type="button" class="btn btn-link btn-sm ub-back-top" (click)="back_to_search()">▲ 回到查詢</button>
            </div>
            <!-- 暱稱是模糊比對且只取一筆,明講出來,免得操作員以為查到的一定是他要找的人 -->
            <div class="ub-note" *ngIf="match_by === 'name'">
                找不到符合的 uid / 手機 / 數字ID，以下是用<strong>暱稱模糊比對</strong>到的第一筆結果。
                若不是你要找的人，請改用 uid 或手機查詢。
            </div>

            <div class="ub-user">
                <img *ngIf="user.profile_pic" [src]="user.profile_pic" class="ub-avatar">
                <div>
                    <div class="ub-user-name">{{user.name}}<span class="ub-code">（{{user.uid}}）</span></div>
                    <div class="ub-user-meta">
                        ID {{user.id}}
                        {{user.gender == 1 ? '男' : (user.gender == 2 ? '女' : '未填')}}
                        鑽石 {{user.diamond | number}}
                        註冊 {{user.create_dt}}
                    </div>
                </div>
            </div>

            <!-- 只取最近 N 批,統計不是全部歷史 —— 明說,不然重度用戶的數字會被當成累計值誤讀 -->
            <div class="ub-note" *ngIf="user_summary?.has_more">
                這位用戶累計上傳 {{user_summary.total_batch | number}} 批，
                以下統計只涵蓋<strong>最近 {{user_summary.batch_count | number}} 批</strong>
                （{{user_summary.first_dt}} ~ {{user_summary.last_dt}}），並非全部歷史。
            </div>

            <div class="ub-tiles" *ngIf="user_summary?.total_events > 0">
                <div class="ub-tile">
                    <div class="ub-tile-label">事件總數{{user_summary.has_more ? '（近期）' : ''}}</div>
                    <div class="ub-tile-value">{{user_summary.total_events | number}}</div>
                </div>
                <div class="ub-tile">
                    <div class="ub-tile-label">上傳批次{{user_summary.has_more ? '（共 ' + user_summary.total_batch + '）' : ''}}</div>
                    <div class="ub-tile-value">{{user_summary.batch_count | number}}</div>
                </div>
                <div class="ub-tile">
                    <div class="ub-tile-label">事件種類</div>
                    <div class="ub-tile-value">{{user_summary.event_kinds | number}}</div>
                </div>
                <div class="ub-tile">
                    <div class="ub-tile-label">涵蓋頁面</div>
                    <div class="ub-tile-value">{{user_summary.page_kinds | number}}</div>
                </div>
                <div class="ub-tile ub-tile-wide">
                    <div class="ub-tile-label">最近上傳</div>
                    <div class="ub-tile-value ub-tile-dt">{{user_summary.last_dt}}</div>
                </div>
            </div>

            <div class="ub-block" *ngIf="user_events?.length > 0">
                <div class="ub-block-title">這位用戶的事件統計</div>
                <app-table-v2 [type]="1" [tcontent]="user_tcontent" [data]="user_events">
                    <ng-template let-post #operation_dk>
                        <div *ngIf="post.key == 'event'">
                            <div class="ub-ev-name">{{eventLabel(post.val.event) || post.val.event}}</div>
                            <div class="ub-code">{{post.val.event}}</div>
                        </div>
                        <div *ngIf="post.key == 'page'">{{pageLabel(post.val.page)}}</div>
                        <div *ngIf="post.key == 'pct'">{{post.val.pct}}%</div>
                    </ng-template>
                </app-table-v2>
            </div>

            <!-- 行為序列:陣列順序即發生順序(事件本身不帶時間戳,只有整批的上傳時間) -->
            <div class="ub-block" *ngIf="batches?.length > 0">
                <div class="ub-block-title">
                    行為序列
                    <span class="ub-block-note">（這位用戶在 App 裡「依序」做了什麼；每列＝一次上傳，點開看動作順序。事件本身不帶時間，只有整批的上傳時間）</span>
                </div>
                <!-- 圖例:解釋藍色左框是什麼 -->
                <div class="ub-seq-legend">
                    <span class="ub-chip ub-chip-enter"><span class="ub-chip-ev">進入○○頁</span></span>
                    <span class="ub-seq-legend-text">左側有<strong>藍色豎條</strong>＝「進入頁面」，代表用戶切到一個新頁面（一段瀏覽的起點）；</span>
                    <span class="ub-chip"><span class="ub-chip-ev">其他動作</span></span>
                    <span class="ub-seq-legend-text">白底＝在該頁面裡做的動作。滑鼠停在任一項目上可看工程端的事件代碼。</span>
                </div>
                <div class="ub-batch" *ngFor="let b of batches">
                    <div class="ub-batch-head" (click)="toggle_batch(b.id)">
                        <span class="ub-batch-toggle">{{open_batch[b.id] ? '▾' : '▸'}}</span>
                        <span class="ub-batch-dt">{{b.create_dt}}</span>
                        <span class="ub-batch-cnt">{{b.event_count | number}} 個事件</span>
                    </div>
                    <div class="ub-seq" *ngIf="open_batch[b.id]">
                        <span class="ub-chip" *ngFor="let e of b.events; let i = index"
                            [ngClass]="{'ub-chip-enter': kindOf(e.event) === 'enter'}"
                            [title]="e.event">
                            <span class="ub-chip-idx">{{i + 1}}</span>
                            <span class="ub-chip-page">{{pageLabel(e.page)}}</span>
                            <span class="ub-chip-ev">{{eventLabel(e.event) || e.event}}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-spinner [loading]="loading"></app-spinner>
